import React from 'react'
import Team01 from '../../../assets/images/shape/team-shape-2.png';
import Team02 from '../../../assets/images/shape/team-shape-2.png';
import Team03 from '../../../assets/images/vivek.jpg';
import Team04 from '../../../assets/images/gurpeet.jpg';
// import Team05 from '../../../assets/images/dinesh.png';
import Team05 from '../../../assets/images/jitender.jpeg';
import Team07 from '../../../assets/images/neha.jpg';
import Team06 from '../../../assets/images/team/team-4.jpg';
import { Link } from 'react-router-dom';

const Teamdata = [    
    {
        Image: Team07,
        name: "Neha Aggarwal",
        position: "Founder"
    },
    {
        Image: Team03,
        name: "Vivek Aggarwal",
        position: "Head - India Operations"
    },
    {
        Image: Team04,
        name: "Gurpreet Pasricha",
        position: "Head - U.S. Operations"
    },
    // {
    //     Image: Team05,
    //     name: "Dinesh Sharma",
    //     position: "Head - Canada Operations"
    // },
    {
        Image: Team05,
        name: "Jitender Luthra",
        position: "Chief Operating Officer"
    },
    
]
const Teamone = () => {
    return (
        <section className="team-one">
            {/* <div className="team-shape-one-1">
                <img src={Team01} alt="shape" />
            </div>
            <div className="team-shape-one-2">
                <img src={Team02} alt="shape" />
            </div> */}
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-12 m-auto">
                        <div className="heading-box text-center">
                            
                            <h2 className="heading-title wow fadeInUp animated animated mb-0 pb-0">
                                Meet the Expert Team
                            </h2>
                            <p className='mb-8 pb-4 mt-3'>Meet the team dedicated to serving NRIs around the world. Our experts bring a wealth of experience and personalized care to guide you every step of the way.</p>
                        </div>
                    </div>
                </div>
                <div className="row ">
                    {Teamdata.map((data, index) =>
                        <div key={index} className="col-lg-3 col-md-6 col-sm-12 text-center p-4">
                            <div className="team-one-box" style={{ border: '1px solid #e0e0e0', borderRadius: '15px', padding: '0px', boxShadow: '0 4px 8px rgba(0,0,0,0.1) ' }}>
                                <img src={data.Image} alt="team-image" className='p-0'  />
                                <div className='text-center mt-3'>
                                    <h5 style={{fontSize : "16px"}}>{data.name}</h5>
                                    <p>{data.position}</p>
                                </div>
                                {/* <div className="team-one-details">
                                    <div className="team-one-details-inner">
                                        <h5>{data.name}</h5>
                                        <p>{data.position}</p> */}
                                        {/* <div className="team-one-social-media">
                                            <ul>
                                                <li><Link to="https://www.facebook.com/" target="_blank"><i className="fa-brands fa-facebook-f" /></Link></li>
                                                <li><Link to="https://www.instagram.com/" target="_blank"><i className="fa-brands fa-instagram" /></Link></li>
                                                <li><Link to="https://in.linkedin.com/" target="_blank"><i className="fa-brands fa-linkedin-in" /></Link></li>
                                                <li><Link to="https://x.com/" target="_blank"><i className="fa-brands fa-twitter" /></Link></li>
                                            </ul>
                                        </div> */}
                                    {/* </div>
                                </div> */}
                            </div>
                        </div>
                    )}
                </div>

            </div>
        </section>

    )
}
export default Teamone;